if (!customElements.get('ctr-best-sellers')) {
  customElements.define(
    'ctr-best-sellers',
    class CtrBestSellers extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.ctr-best-sellers__slider-wrapper',
          nextEl: '.ctr-best-sellers__nav-btn--next',
          prevEl: '.ctr-best-sellers__nav-btn--prev',
          pagination: '.ctr-best-sellers__slider-controls .swiper-pagination',
        };
        this.classes = {
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
        this.sliderInstance = false;

        this.initSlider();
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;

        this.sliderOptions = {
          slidesPerView: "auto",
          spaceBetween: 16,
          navigation: {
            nextEl: this.querySelector(this.selectors.nextEl),
            prevEl: this.querySelector(this.selectors.prevEl),
          },
          pagination: {
            el: this.querySelector(this.selectors.pagination),
            clickable: true,
          },
          loop: false,
          threshold: 2,
          watchSlidesProgress: true,
          breakpoints: {
            768: {
              slidesPerView: "auto",
              spaceBetween: 16,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 16,
            },
          },
        };

        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions);
        this.sliderInstance.init();
      }
    }
  );
}
